import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { CaretButtonComponent } from './caret-button.component';
import { MenuItemComponent } from './menu-item.component';
import { MenuItem } from './menu-item.types';
import { HKButtonDirective } from './hk-button.dirrective';
import { SearchFieldComponent } from './search-field.component';
import { IconWithLabelComponent } from './icon-with-label.component';

@Component({
  selector: 'hk-overview-card-header',
  template: `
    <div
      [ngClass]="{ 'border-b': !!titleText, '-ml-6 -mr-6 mt-0 pl-6 pr-6 shadow-md': isScrolled }"
      class="header mt-4 flex h-9 content-baseline items-baseline justify-between border-hk_gray-100 pb-1"
    >
      <ng-content select="[header-title-content]"></ng-content>
      <span *ngIf="!searchActive" class="mat-headline-6 !mb-1 flex items-center gap-2 pt-0.5">
        {{ titleText | translate }}
        <div
          *ngIf="titleBadge"
          class="inline-flex h-4 min-w-5 items-center justify-center gap-2.5 rounded-full border-x border-y border-hk_gray-100 bg-hk_gray-25 p-1 text-xxs text-black"
        >
          {{ titleBadge }}
        </div>
      </span>
      <div class="flex flex-1 items-center justify-end gap-1">
        <div class="flex flex-1 justify-end" *ngIf="searchEnabled">
          <hk-search-field class="flex flex-1" (searchValueChange)="searchValueChange.emit($event)" *ngIf="searchActive"></hk-search-field>
          <button (click)="searchActive = true">
            <hk-icon-with-label *ngIf="!searchActive" [iconClass]="'ph ph-magnifying-glass'"></hk-icon-with-label>
          </button>
          <button (click)="searchActive = false; searchValueChange.emit()">
            <hk-icon-with-label *ngIf="searchActive" [iconClass]="'ph ph-x'"></hk-icon-with-label>
          </button>
        </div>

        <button
          [ngClass]="{ 'bg-hk_gray-100': button.isSelected && button.isSelected(button) }"
          *ngFor="let button of tabMenuButtons"
          (click)="button.callback && button.callback()"
          color="basic"
          hk-button-stroked
        >
          <i ngClass="{{ button.iconName }}"></i>
          {{ button.i18nKey | translate }}
        </button>

        <hk-caret-button
          (clickButton)="caretButtonClicked.emit()"
          *ngIf="caretButtonText || showCaretButton"
          [disabled]="caretButtonDisabled"
          [text]="caretButtonText | translate"
          [attr.data-testid]="'cardHeader.' + caretButtonText"
          class="font-bold"
        ></hk-caret-button>
        <ng-content></ng-content>
        <button *ngIf="cardMenuItems.length" hk-button-flat [matMenuTriggerFor]="cardMenu.childMenu">
          <i class="ph ph-dots-three-vertical"></i>
        </button>
      </div>
    </div>
    <hk-app-menu-item #cardMenu [items]="cardMenuItems"></hk-app-menu-item>
  `,
  host: { class: 'flex flex-col' },
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    MatMenuTrigger,
    CaretButtonComponent,
    MenuItemComponent,
    HKButtonDirective,
    NgIf,
    SearchFieldComponent,
    IconWithLabelComponent,
    CommonModule,
  ],
})
export class OverviewCardHeaderComponent {
  @Input() public titleText = '';
  @Input() public caretButtonText = '';
  @Input() public caretButtonDisabled = false;
  @Input() public showCaretButton = false;
  @Output() caretButtonClicked = new EventEmitter<void>();
  @Input() isScrolled = false;
  @Input() cardMenuItems = [] as MenuItem[];
  @Input() public titleBadge: number | undefined;
  @Input() public searchEnabled = false;
  @Input() public tabMenuButtons = [] as MenuItem[];
  @Output() searchValueChange = new EventEmitter<string>();
  searchActive = false;
}
